(function () {
  if (window.__sathiLoadMore) return;
  window.__sathiLoadMore = true;

  var PAGE_CAP = 10;
  var LOADING_TEXT = (function () {
    var p = document.getElementById('InfinitePagination');
    return (p && p.getAttribute('data-loading-text')) || '読み込み中…';
  })();
  var loading = false;
  var prefetchCache = {};
  var lastLabelText = null;

  var supported = !!(window.fetch && window.DOMParser && window.URL &&
    window.URLSearchParams && window.sessionStorage && window.requestAnimationFrame);

  function getContainer() { return document.getElementById('CollectionLoop'); }
  function getPag() { return document.getElementById('InfinitePagination'); }
  function sectionId() {
    var c = getContainer();
    return c ? c.getAttribute('data-section-id') : null;
  }
  function stateKey() {
    try {
      var u = new URL(location.href);
      ['page', 'section_id', 'preview_theme_id', 'key', 'pb', '_ab', '_fd'].forEach(function (p) {
        u.searchParams.delete(p);
      });
      if (u.searchParams.sort) u.searchParams.sort();
      var qs = u.searchParams.toString();
      return 'loadmore:' + u.pathname + (qs ? '?' + qs : '');
    } catch (e) {
      return 'loadmore:' + location.pathname;
    }
  }
  function pageOf(href) {
    try {
      return parseInt(new URL(href, location.href).searchParams.get('page') || '1', 10) || 1;
    } catch (e) { return 1; }
  }
  function withSection(href) {
    var u = new URL(href, location.href);
    var sid = sectionId();
    if (sid) u.searchParams.set('section_id', sid);
    return u.toString();
  }
  function parseDoc(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return { loop: doc.getElementById('CollectionLoop'), pag: doc.getElementById('InfinitePagination') };
  }
  function validated(res) {
    if (!res.loop) throw new Error('no grid');
    return res;
  }
  function fetchFragment(href) {
    return fetch(withSection(href))
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(parseDoc).then(validated)
      .catch(function () {
        return fetch(href)
          .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
          .then(parseDoc).then(validated);
      });
  }
  function prefetch(href) {
    if (!href) return null;
    if (!prefetchCache[href]) {
      var p = fetchFragment(href);
      p.catch(function () { delete prefetchCache[href]; });
      prefetchCache[href] = p;
    }
    return prefetchCache[href];
  }
  function saveState(upTo) {
    try {
      var cur = {};
      try { cur = JSON.parse(sessionStorage.getItem(stateKey())) || {}; } catch (e) {}
      if (upTo) cur.upTo = upTo;
      cur.scroll = window.scrollY;
      sessionStorage.setItem(stateKey(), JSON.stringify(cur));
    } catch (e) {}
  }
  function reveal(container) {
    var nodes = container.querySelectorAll('[data-aos]');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('aos-animate');
  }
  function appendFragment(res) {
    if (!res.loop) return false;
    var container = getContainer();
    if (!container) return false;
    while (res.loop.firstChild) container.appendChild(res.loop.firstChild);
    reveal(container);
    var pag = getPag();
    if (pag) {
      if (res.pag && res.pag.querySelector('a')) {
        pag.innerHTML = res.pag.innerHTML;
        pag.style.display = '';
      } else {
        pag.style.display = 'none';
      }
    }
    return true;
  }

  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            var a = entries[i].target.querySelector('a');
            if (a) prefetch(a.href);
          }
        }
      }, { rootMargin: '600px' })
    : null;

  function armPrefetch() {
    var pag = getPag();
    if (!pag) return;
    if (io) { io.disconnect(); io.observe(pag); }
    pag.addEventListener('pointerenter', function () {
      var a = pag.querySelector('a');
      if (a) prefetch(a.href);
    }, { once: true });
  }

  function watchRerender() {
    var wrap = document.querySelector('[data-products-grid]');
    if (!wrap || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      prefetchCache = {};
      loading = false;
      armPrefetch();
    }).observe(wrap, { childList: true });
  }

  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('#InfinitePagination a') : null;
    if (!link) return;
    if (!supported) return; // old browsers: navigate the real ?page=N link
    e.preventDefault();
    if (loading) return;
    loading = true;
    var href = link.href;
    var containerAtClick = getContainer();
    var keyAtClick = stateKey();
    var label = link.querySelector('span') || link;
    lastLabelText = label.textContent;
    label.textContent = LOADING_TEXT;
    prefetch(href).then(function (res) {
      delete prefetchCache[href]; // fragment nodes are moved out — never replay
      if (getContainer() !== containerAtClick || stateKey() !== keyAtClick) {
        loading = false;
        return; // grid was re-rendered by filters/sort while in flight
      }
      if (appendFragment(res)) saveState(pageOf(href));
      loading = false;
      armPrefetch();
    }).catch(function () {
      delete prefetchCache[href];
      loading = false;
      label.textContent = lastLabelText;
    });
  });

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    loading = false;
    prefetchCache = {};
    // bfcache brought back a page frozen mid-restore: drop dangling
    // placeholders and bring the load-more button back so the user can
    // continue manually from what actually loaded.
    var leftovers = document.querySelectorAll('[data-restore-ph]');
    if (leftovers.length) {
      for (var i = 0; i < leftovers.length; i++) {
        if (leftovers[i].parentNode) leftovers[i].parentNode.removeChild(leftovers[i]);
      }
      var pagStuck = getPag();
      if (pagStuck && pagStuck.querySelector('a')) pagStuck.style.display = '';
    }
    var pag = getPag();
    if (pag) {
      var a = pag.querySelector('a');
      var label = a ? (a.querySelector('span') || a) : null;
      if (label && label.textContent === LOADING_TEXT && lastLabelText) {
        label.textContent = lastLabelText;
      }
    }
    armPrefetch();
  });

  function restore() {
    var raw = null;
    try { raw = sessionStorage.getItem(stateKey()); } catch (e) {}
    if (!raw) return;
    var st;
    try { st = JSON.parse(raw); } catch (e) { return; }
    if (!st) return;
    var startPage = pageOf(location.href);
    var target = Math.min(st.upTo || 1, PAGE_CAP);
    if (target <= startPage) return; // native scroll restoration handles it
    var container = getContainer();
    if (!container) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    // Reserve space: one full-row placeholder per missing page, then land on
    // the saved position IMMEDIATELY. Pages fill in around the user.
    var perPageH = container.getBoundingClientRect().height;
    var placeholders = {};
    var pageNodes = {};
    var pages = [];
    var n, ph;
    for (n = startPage + 1; n <= target; n++) {
      ph = document.createElement('div');
      ph.style.cssText = 'grid-column:1/-1;width:100%;height:' + perPageH + 'px;background:rgba(0,0,0,0.02);';
      ph.setAttribute('data-restore-ph', n);
      container.appendChild(ph);
      placeholders[n] = ph;
      pages.push(n);
    }
    var pag = getPag();
    if (pag) pag.style.display = 'none';
    loading = true;
    if (st.scroll) window.scrollTo(0, st.scroll);

    // fetch the page under the viewport first
    var vy = (st.scroll || 0) + window.innerHeight / 2;
    var priority = null;
    for (n = startPage + 1; n <= target; n++) {
      var r = placeholders[n].getBoundingClientRect();
      var top = r.top + window.scrollY;
      if (priority === null && vy >= top && vy < top + r.height) priority = n;
    }
    var order = priority
      ? [priority].concat(pages.filter(function (p) { return p !== priority; }))
      : pages.slice();

    var results = {};
    var firstFail = null;
    var settledCount = 0;
    var idx = 0;
    var inFlight = 0;
    var CONCURRENCY = 3;

    function fill(p) {
      if (getContainer() !== container) return;
      var phEl = placeholders[p];
      var res = results[p];
      if (!phEl || !res) return;
      pageNodes[p] = [];
      while (res.loop.firstChild) {
        var node = res.loop.firstChild;
        container.insertBefore(node, phEl);
        if (node.nodeType === 1) pageNodes[p].push(node);
      }
      if (phEl.parentNode) phEl.parentNode.removeChild(phEl);
      delete placeholders[p];
      reveal(container);
    }

    function finalize() {
      if (getContainer() !== container) { loading = false; return; }
      if (firstFail !== null) {
        // drop filled pages at/after the gap so the list stays continuous
        Object.keys(pageNodes).forEach(function (k) {
          var p = parseInt(k, 10);
          if (p >= firstFail) {
            for (var i = 0; i < pageNodes[p].length; i++) {
              var nd = pageNodes[p][i];
              if (nd.parentNode) nd.parentNode.removeChild(nd);
            }
            delete pageNodes[p];
          }
        });
      }
      Object.keys(placeholders).forEach(function (k) {
        var el = placeholders[k];
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      if (pag) {
        if (firstFail !== null) {
          var a = pag.querySelector('a');
          if (a) {
            try {
              var u = new URL(location.href);
              u.searchParams.set('page', firstFail);
              a.href = u.toString();
            } catch (e) {}
          }
          pag.style.display = '';
        } else {
          var lastRes = results[target];
          if (lastRes && lastRes.pag && lastRes.pag.querySelector('a')) {
            pag.innerHTML = lastRes.pag.innerHTML;
            pag.style.display = '';
          } else {
            pag.style.display = 'none';
          }
        }
      }
      loading = false;
      armPrefetch();
      // exact correction once real layout is in — unless the user moved on
      if (firstFail === null && st.scroll &&
          Math.abs(window.scrollY - st.scroll) < window.innerHeight * 0.75) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { window.scrollTo(0, st.scroll); });
        });
      }
    }

    function settle() {
      settledCount++;
      for (var i = 0; i < pages.length; i++) {
        var p = pages[i];
        if (results[p] && placeholders[p] && (firstFail === null || p < firstFail)) fill(p);
      }
      if (settledCount === pages.length) { finalize(); return; }
      next();
    }

    function launch(p) {
      inFlight++;
      var u;
      try { u = new URL(location.href); } catch (e) { inFlight--; return; }
      u.searchParams.set('page', p);
      fetchFragment(u.toString()).then(function (res) {
        inFlight--;
        results[p] = res;
        settle();
      }, function () {
        inFlight--;
        if (firstFail === null || p < firstFail) firstFail = p;
        settle();
      });
    }
    function next() {
      while (idx < order.length && inFlight < CONCURRENCY) launch(order[idx++]);
    }
    next();
  }

  function init() {
    if (!getContainer() || !supported) return;
    window.addEventListener('pagehide', function () { saveState(); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') saveState();
    });
    document.addEventListener('shopify:section:load', function () { armPrefetch(); });

    var navEntry = null;
    try { navEntry = (performance.getEntriesByType && performance.getEntriesByType('navigation') || [])[0] || null; } catch (e) {}
    var legacyBack = !!(performance.navigation && performance.navigation.type === 2);
    var isBack = (navEntry && navEntry.type === 'back_forward') || legacyBack || document.wasDiscarded === true;
    var known = !!navEntry || !!performance.navigation;
    if (isBack) {
      restore();
    } else if (known) {
      try { sessionStorage.removeItem(stateKey()); } catch (e) {}
    }
    watchRerender();
    armPrefetch();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
